export const industriesMainItemMobile = [
    {
        id: 1,
        title: "On Demand",
        onDemand: [
            {
                id: 1,
                image: "/assets/Header/industries/ondemand/Consumer goods",
                href: "/on-demand/consumer-goods-and-services",
                title: "Consumer Goods And Services",
            },
            {
                id: 2,
                image: "/assets/Header/industries/ondemand/Crowdfunding",
                href: "/on-demand/crowdfunding-consulting-services",
                title: "Crowdfunding Consulting Services",
            },
            {
                id: 3,
                image: "/assets/Header/industries/ondemand/Education",
                title: "Education App Development",
                href: "/on-demand/education-app-development",
            },
            {
                id: 4,
                image: "/assets/Header/industries/ondemand/Recruiting",
                title: "Recruiting App Development",
                href: "/on-demand/recruiting-app-development",
            },
            {
                id: 5,
                image: "/assets/Header/industries/ondemand/Delivery",
                title: "Delivery App Development",
                href: "/on-demand/delivery-app-development",
            },
            {
                id: 6,
                image: "/assets/Header/industries/ondemand/Food",
                title: "Food Delivery App Development",
                href: "/on-demand/food-delivery-app-development",
            },
            {
                id: 7,
                image: "/assets/Header/industries/ondemand/Transportation",
                title: "Logistics And Transportation Software Development",
                href: "/on-demand/logistics-and-transportation-services",
            },
        ],
    },
    {
        id: 2,
        title: "Food And Restaurant",
        foodRestaurant: [
            {
                id: 1,
                image: "/assets/Header/industries/food&resto/1",
                title: "Point-of-sale systems",
                href: "/food-and-restaurant/point-of-sale-systems-services",
            },
            {
                id: 2,
                image: "/assets/Header/industries/food&resto/2",
                title: "Accounting software",
                href: "/food-and-restaurant/accounting-software-services",
            },
            {
                id: 3,
                image: "/assets/Header/industries/food&resto/3",
                title: "Loyalty programs",
                href: "/food-and-restaurant/loyalty-programs-development",
            },
            {
                id: 4,
                image: "/assets/Header/industries/food&resto/4",
                title: "Online ordering platforms",
                href: "/food-and-restaurant/online-ordering-platform-development",
            },
            {
                id: 5,
                image: "/assets/Header/industries/food&resto/5",
                title: "Third-party delivery apps",
                href: "/food-and-restaurant/third-party-delivery-apps",
            },
            {
                id: 6,
                image: "/assets/Header/industries/food&resto/6",
                title: "Employee training applications",
                href: "/food-and-restaurant/training-development-services",
            },
            {
                id: 7,
                image: "/assets/Header/industries/food&resto/7",
                title: "Scheduling software",
                href: "/food-and-restaurant/software-development-planning",
            },
            {
                id: 8,
                image: "/assets/Header/industries/food&resto/8",
                title: "Payroll programs",
                href: "/food-and-restaurant/payroll-software-development",
            },
        ],
    },
    {
        id: 3,
        title: "Banking",
        bankingFinance: [
            {
                id: 1,
                image: "/assets/Header/industries/banking/core",
                title: "Core Banking",
                href: "/banking/core-banking-software-development",
            },
            {
                id: 2,
                image: "/assets/Header/industries/banking/corporate",
                title: "Corporate Banking",
                href: "/banking/corporate-banking-development-services",
            },
            {
                id: 3,
                image: "/assets/Header/industries/banking/credit",
                title: "Credits And Loans",
                href: "/banking/loan-lending-app-development",
            },
            {
                id: 4,
                image: "/assets/Header/industries/banking/fraud",
                title: "Fraud Protection",
                href: "/banking/fraud-detection-software-development-company",
            },
            {
                id: 5,
                image: "/assets/Header/industries/banking/investment",
                title: "Investments",
                href: "/banking/finance-app-development",
            },
            {
                id: 6,
                image: "/assets/Header/industries/banking/operatio",
                title: "AI Development Services for Banking",
                href: "/banking/ai-development-services",
            },

            {
                id: 7,
                image: "/assets/Header/industries/banking/risk",
                title: "Risk Management",
                href: "/banking/risk-management-software-development",
            },
            {
                id: 8,
                image: "/assets/Header/industries/banking/welth",
                title: "Wealth Management",
                href: "/banking/wealth-management-software-development",
            },
        ],
    },
    {
        id: 4,
        title: "Ecommerce",
        ecommerce: [
            {
                id: 1,
                image: "/assets/Header/industries/ecommerce/online",
                title: "Online Stores",
                href: "/ecommerce/online-store-app-development",
            },
            {
                id: 2,
                image: "/assets/Header/industries/ecommerce/b2bmarket",
                title: "B2B Marketplace",
                href: "/ecommerce/b2c-marketplace-development",
            },
            {
                id: 3,
                image: "/assets/Header/industries/ecommerce/b2bportal",
                title: "B2B Portals",
                href: "/ecommerce/b2b-portals-development",
            },
            {
                id: 4,
                image: "/assets/Header/industries/ecommerce/auctions",
                title: "Auctions and Bidding Platforms",
                href: "/ecommerce/custom-auction-software-development",
            },
            {
                id: 5,
                image: "/assets/Header/industries/ecommerce/ecomm",
                title: "Ecommerce Aggregators",
                href: "/ecommerce/ecommerce-aggregators-app",
            },
            {
                id: 6,
                image: "/assets/Header/industries/ecommerce/booking",
                title: "Booking & Ticketing Solutions",
                href: "/ecommerce/ticket-booking-solutions",
            },
            {
                id: 7,
                image: "/assets/Header/industries/ecommerce/design",
                title: "Design concept",
                href: "/ecommerce/design-concept-development",
            },
            {
                id: 8,
                image: "/assets/Header/industries/ecommerce/web",
                title: "Ecommerce Web development Company",
                href: "/ecommerce/website-development",
            },
            {
                id: 9,
                image: "/assets/Header/industries/ecommerce/sof",
                title: "Ecommerce Software Development Services",
                href: "/ecommerce/software-development-services",
            },
            {
                id: 10,
                image: "/assets/Header/industries/ecommerce/shopping",
                title: "Shopping Cart Development",
                href: "/ecommerce/shopping-cart-development",
            },
            {
                id: 11,
                image: "/assets/Header/industries/ecommerce/ecomweb",
                title: "Ecommerce Website Design and Development",
                href: "/ecommerce/website-design",
            },
            {
                id: 12,
                image: "/assets/Header/industries/ecommerce/store",
                title: "E-commerce Store Customization",
                href: "/ecommerce/store-customization-services",
            },
            {
                id: 13,
                image: "/assets/Header/industries/ecommerce/marketplace",
                title: "E-commerce Marketplace Development",
                href: "/ecommerce/marketplace-development",
            },
            {
                id: 14,
                image: "/assets/Header/industries/ecommerce/mobile",
                title: "E-commerce Mobile Application Development Services",
                href: "/ecommerce/mobile-app-development",
            },
            {
                id: 15,
                image: "/assets/Header/industries/ecommerce/payment",
                title: "E-commerce Payment Gateway Integration",
                href: "/ecommerce/payment-gateway-integration",
            },
            {
                id: 16,
                image: "/assets/Header/industries/ecommerce/chatbot",
                title: "E-commerce Chatbot Development",
                href: "/ecommerce/chatbot-development-company",
            },
            {
                id: 17,
                image: "/assets/Header/industries/ecommerce/retail",
                title: "E-commerce and Retail Software Development Solutions",
                href: "/ecommerce/retail-ecommerce-software-development",
            },
            {
                id: 18,
                image: "/assets/Header/industries/ecommerce/analytics",
                title: "E-commerce Analytics",
                href: "/ecommerce/analytics-services",
            },
        ],
    },
    {
        id: 5,
        title: "Healthcare",
        healthcareFitness: [
            {
                id: 1,
                image: "/assets/Header/industries/healthcare/Metaverse In The Healthcare Industry",
                title: "Metaverse In The Healthcare Industry",
                href: "/healthcare/metaverse-in-the-healthcare-industry",
            },
            {
                id: 2,
                image: "/assets/Header/industries/healthcare/electonic",
                title: "Electronic Health Records Software",
                href: "/healthcare/electronic-health-records-software",
            },
            {
                id: 3,
                image: "/assets/Header/industries/healthcare/telemedicine",
                title: "Telemedicine Software",
                href: "/healthcare/telemedicine-software-development-services",
            },
            {
                id: 4,
                image: "/assets/Header/industries/healthcare/medicalimage",
                title: "Medical Image Analysis Software",
                href: "/healthcare/medical-image-analysis-software",
            },
            {
                id: 5,
                image: "/assets/Header/industries/healthcare/hospital",
                title: "Hospital Management Software",
                href: "/healthcare/hospital-management-software-system",
            },
            {
                id: 6,
                image: "/assets/Header/industries/healthcare/e",
                title: "E-Prescribing Software",
                href: "/healthcare/e-prescription-software-development",
            },
            {
                id: 7,
                image: "/assets/Header/industries/healthcare/remote",
                title: "Remote Patient Monitoring Software",
                href: "/healthcare/remote-patient-monitoring",
            },
            {
                id: 8,
                image: "/assets/Header/industries/healthcare/health",
                title: "Healthcare Billing Software",
                href: "/healthcare/healthcare-billing-software-development",
            },
            {
                id: 9,
                image: "/assets/Header/industries/healthcare/trial",
                title: "Clinical Trial Management Software",
                href: "/healthcare/clinical-trial-management-software",
            },
            {
                id: 10,
                image: "/assets/Header/industries/healthcare/PHR",
                title: "PHR App Development",
                href: "/healthcare/phr-app-development",
            },
            {
                id: 11,
                image: "/assets/Header/industries/healthcare/Vector",
                title: "Advanced Clinical Trial Management System",
                href: "/healthcare/ctms-solutions",
            },
            {
                id: 12,
                image: "/assets/Header/industries/healthcare/crm",
                title: "Healthcare CRM Software",
                href: "/healthcare/dynamics-365-health-crm-solution",
            },
            {
                id: 13,
                image: "/assets/Header/industries/healthcare/research",
                title: "Medical Research Software",
                href: "/healthcare/medical-research",
            },
            {
                id: 14,
                image: "/assets/Header/industries/healthcare/mapp",
                title: "Healthcare Mobile App Development",
                href: "/healthcare/healthcare-mobile-app-development",
            },
            {
                id: 15,
                image: "/assets/Header/industries/healthcare/fitnessn",
                title: "Fitness Tracking App Development",
                href: "/healthcare/fitness-tracking-app-development",
            },
        ],
    },
    {
        id: 6,
        title: "Education",
        education: [
            {
                id: 1,
                image: "/assets/Header/industries/education/authoring",
                title: "Authoring Systems",
                href: "/education/authoring-software-development-systems",
            },
            {
                id: 2,
                image: "/assets/Header/industries/education/assessment",
                title: "Assessment Software",
                href: "/education/assessment-software-development",
            },
            {
                id: 3,
                image: "/assets/Header/industries/education/drill",
                title: "Drill & Practics Software",
                href: "/education/drill-and-practice-software-development",
            },
            {
                id: 4,
                image: "/assets/Header/industries/education/special",
                title: "Special Needs Software",
                href: "/education/special-needs-software",
            },
            {
                id: 5,
                image: "/assets/Header/industries/education/courseware",
                title: "Courseware Developmenyt Service",
                href: "/education/courseware-development",
            },
            {
                id: 6,
                image: "/assets/Header/industries/education/programmable",
                title: "Programmable Systems",
                href: "/education/programmable-system",
            },
            {
                id: 7,
                image: "/assets/Header/industries/education/vr",
                title: "Virtual Reality Applications",
                href: "/education/virtual-reality-development-services",
            },
            {
                id: 8,
                image: "/assets/Header/industries/education/hyper",
                title: "Hypermedia",
                href: "/education/adaptive-hypermedia-system",
            },
            {
                id: 9,
                image: "/assets/Header/industries/education/tutorial",
                title: "Tutorial Software",
                href: "/education/tutorial-software-development",
            },
            {
                id: 10,
                image: "/assets/Header/industries/education/reference",
                title: "Reference Software",
                href: "/education/reference-software-development",
            },

            {
                id: 11,
                image: "/assets/Header/industries/education/math",
                title: "Math Problem Solving Software",
                href: "/education/math-problem-solving-software-development",
            },

            {
                id: 12,
                image: "/assets/Header/industries/education/edrobotics",
                title: "Educational Robotics & MBL",
                href: "/education/educational-robotics-mbl",
            },
            {
                id: 13,
                image: "/assets/Header/industries/education/graphic",
                title: "Graphic Software",
                href: "/education/graphic-software-development",
            },
            {
                id: 14,
                image: "/assets/Header/industries/education/utility",
                title: "Utility Software",
                href: "/education/utility-software-development",
            },
            {
                id: 15,
                image: "/assets/Header/industries/education/intelli",
                title: "Intelligent Tutoring Systems",
                href: "/education/intelligent-tutoring-system",
            },
            {
                id: 16,
                image: "/assets/Header/industries/education/colla",
                title: "Collaborative Distance Learning Systems",
                href: "/education/collaborative-distance-learning-system",
            },
        ],
    },

    // {
    //   id: 4,
    //   title: "Gaming",
    //   gaming: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Metal",
    //       href: "/",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Amazon Lumberyard",
    //       href: "/",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Blender",
    //       href: "/",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Construct 3",
    //       href: "/",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/Our-company",
    //       title: "GameMaker",
    //       href: "/",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/Our-company",
    //       title: "CRYENGINE",
    //       href: "/",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Godot Engine",
    //       href: "/",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Maya LT",
    //       href: "/",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Gamefroot",
    //       href: "/",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/Our-company",
    //       title: "GDevelop",
    //       href: "/",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/Our-company",
    //       title: "GameSalad",
    //       href: "/",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/Our-company",
    //       title: "DeltaEngine",
    //       href: "/",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Panda3D",
    //       href: "/",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Superpowers",
    //       href: "/",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/Our-company",
    //       title: "RPG Maker VX Ace",
    //       href: "/",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Cocos2d-x",
    //       href: "/",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Corona",
    //       href: "/",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Clickteam Fusion",
    //       href: "/",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/Our-company",
    //       title: "MonoGame",
    //       href: "/",
    //     },
    //     {
    //       id: 20,
    //       image: "/assets/Header/About/Our-company",
    //       title: "NeoAxis Engine",
    //       href: "/",
    //     },
    //     {
    //       id: 21,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Photon",
    //       href: "/",
    //     },
    //     {
    //       id: 22,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Helix Core",
    //       href: "/",
    //     },
    //     {
    //       id: 23,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Leadwerks",
    //       href: "/",
    //     },
    //     {
    //       id: 24,
    //       image: "/assets/Header/About/Our-company",
    //       title: "SpriteKit",
    //       href: "/",
    //     },
    //     {
    //       id: 25,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Arcweave",
    //       href: "/",
    //     },
    //     {
    //       id: 26,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Stencyl",
    //       href: "/",
    //     },
    //     {
    //       id: 27,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Defold",
    //       href: "/",
    //     },
    //     {
    //       id: 28,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Starling",
    //       href: "/",
    //     },
    //     {
    //       id: 29,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Haxe",
    //       href: "/",
    //     },
    //     {
    //       id: 30,
    //       image: "/assets/Header/About/Our-company",
    //       title: "GamePlay3D",
    //       href: "/",
    //     },
    //   ],
    // },

    // {
    //   id: 6,
    //   title: "Taxi Booking",
    //   texiBooking: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Onde",
    //       href: "/",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Cabsoluit",
    //       href: "/",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/Our-company",
    //       title: "AllRide",
    //       href: "/",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/Our-company",
    //       title: "SpotnRides",
    //       href: "/",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/Our-company",
    //       title: "SmartCar",
    //       href: "/",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Infinite Cab",
    //       href: "/",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Taxi Mobile Solutions",
    //       href: "/",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Limo n' Taxi",
    //       href: "/",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/Our-company",
    //       title: "CabbyGo",
    //       href: "/",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/Our-company",
    //       title: "TaxiCaller",
    //       href: "/",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/Our-company",
    //       title: "RideBits",
    //       href: "/",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Mtoag Taxi App",
    //       href: "/",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/Our-company",
    //       title: "ESuper",
    //       href: "/",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/Our-company",
    //       title: "TaxiTapp",
    //       href: "/",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Taxi On The Go",
    //       href: "/",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Sherlock Taxi Solution",
    //       href: "/",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/Our-company",
    //       title: "FareBookings.com",
    //       href: "/",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/Our-company",
    //       title: "YelowTaxi",
    //       href: "/",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/Our-company",
    //       title: "PerGo Dispatch",
    //       href: "/",
    //     },
    //     {
    //       id: 20,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Call Taxi Management System",
    //       href: "/",
    //     },
    //     {
    //       id: 21,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Eber",
    //       href: "/",
    //     },
    //     {
    //       id: 22,
    //       image: "/assets/Header/About/Our-company",
    //       title: "TaxiMobility",
    //       href: "/",
    //     },
    //     {
    //       id: 23,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Taxi Pulse",
    //       href: "/",
    //     },
    //     {
    //       id: 24,
    //       image: "/assets/Header/About/Our-company",
    //       title: "UnicoTaxi",
    //       href: "/",
    //     },
    //     {
    //       id: 25,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tagmytaxi",
    //       href: "/",
    //     },
    //     {
    //       id: 26,
    //       image: "/assets/Header/About/Our-company",
    //       title: "CabStartup",
    //       href: "/",
    //     },
    //     {
    //       id: 27,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Voila Cabs",
    //       href: "/",
    //     },
    //     {
    //       id: 28,
    //       image: "/assets/Header/About/Our-company",
    //       title: "BooknRide",
    //       href: "/",
    //     },
    //   ],
    // },
    // {
    //   id: 7,
    //   title: "Dating",
    //   dating: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Bumble: Dating & Friends app",
    //       href: "/",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tinder: Dating app. Meet. Chat",
    //       href: "/",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hinge Dating App: Meet People",
    //       href: "/",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Badoo - Dating. Chat. Meet.",
    //       href: "/",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Dating and Chat - SweetMeet",
    //       href: "/",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hily: Dating app. Meet People. ",
    //       href: "/",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Chispa: Dating App for Latinos",
    //       href: "/",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Dating with singles - iHappy",
    //       href: "/",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/Our-company",
    //       title: "BLK Dating: Meet Black Singles",
    //       href: "/",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Dating and Chat - Evermatch",
    //       href: "/",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Match Dating: Chat, Date, Meet",
    //       href: "/",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/Our-company",
    //       title: "OkCupid - Dating App",
    //       href: "/",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Zoosk - Social Dating App",
    //       href: "/",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Dating and chat - Maybe You",
    //       href: "/",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/Our-company",
    //       title: "YouFlirt - flirt & chat app",
    //       href: "/",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/Our-company",
    //       title: "3Fun: Threesome Couples Dating",
    //       href: "/",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Seeking",
    //       href: "/",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Turn Up - Match through music!",
    //       href: "/",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Magnet: Meet & Chat Dating App",
    //       href: "/",
    //     },
    //     {
    //       id: 20,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Ukaku - Live video chat",
    //       href: "/",
    //     },
    //     {
    //       id: 21,
    //       image: "/assets/Header/About/Our-company",
    //       title: "InterracialCupid: Mixed Dating",
    //       href: "/",
    //     },
    //     {
    //       id: 22,
    //       image: "/assets/Header/About/Our-company",
    //       title: "AsianDating: Asian Dating",
    //       href: "/",
    //     },
    //     {
    //       id: 23,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Mingle2: Dating, Chat & Meet",
    //       href: "/",
    //     },
    //     {
    //       id: 24,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Global Video call Random Cally",
    //       href: "/",
    //     },
    //     {
    //       id: 25,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Threesome Swingers App - 3way",
    //       href: "/",
    //     },
    //     {
    //       id: 26,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Wild: Hook up, Meet, Dating Me",
    //       href: "/",
    //     },
    //   ],
    // },
    // {
    //   id: 8,
    //   title: "Travel & Transport",
    //   travelTransport: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/Our-company",
    //       title: "TripActions",
    //       href: "/",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/Our-company",
    //       title: "TravelPerk",
    //       href: "/",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/Our-company",
    //       title: "iGMS",
    //       href: "/",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hosthub",
    //       href: "/",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Bookster",
    //       href: "/",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hostaway",
    //       href: "/",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tourwriter",
    //       href: "/",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/Our-company",
    //       title: "NexTravel",
    //       href: "/",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tourdesk",
    //       href: "/",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Roundme",
    //       href: "/",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Bookeo",
    //       href: "/",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/Our-company",
    //       title: "NextBillion.ai",
    //       href: "/",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/Our-company",
    //       title: "YouLi",
    //       href: "/",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Minim",
    //       href: "/",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Itilite",
    //       href: "/",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Routespring",
    //       href: "/",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/Our-company",
    //       title: "FunAway",
    //       href: "/",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/Our-company",
    //       title: "RateBoard",
    //       href: "/",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Rentals United",
    //       href: "/",
    //     },
    //     {
    //       id: 20,
    //       image: "/assets/Header/About/Our-company",
    //       title: "BookingSync",
    //       href: "/",
    //     },
    //     {
    //       id: 21,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hostfully",
    //       href: "/",
    //     },
    //     {
    //       id: 22,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tokeet",
    //       href: "/",
    //     },
    //     {
    //       id: 23,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Locomote",
    //       href: "/",
    //     },
    //     {
    //       id: 24,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Ezus",
    //       href: "/",
    //     },
    //     {
    //       id: 25,
    //       image: "/assets/Header/About/Our-company",
    //       title: "bookingkit",
    //       href: "/",
    //     },
    //     {
    //       id: 26,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Quicktext",
    //       href: "/",
    //     },
    //     {
    //       id: 27,
    //       image: "/assets/Header/About/Our-company",
    //       title: "MiX Telematics",
    //       href: "/",
    //     },
    //     {
    //       id: 28,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Phptravels",
    //       href: "/",
    //     },
    //     {
    //       id: 29,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Transporters.io",
    //       href: "/",
    //     },
    //     {
    //       id: 30,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Advensure",
    //       href: "/",
    //     },
    //   ],
    // },
    // {
    //   id: 9,
    //   title: "Events & Tickets",
    //   eventsTickets: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Cvent",
    //       href: "/",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Webex Events",
    //       href: "/",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hubilo",
    //       href: "/",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Whova",
    //       href: "/",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/Our-company",
    //       title: "vFairs",
    //       href: "/",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Eventbrite",
    //       href: "/",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Airmeet",
    //       href: "/",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Hopin",
    //       href: "/",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Bizzabo",
    //       href: "/",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tourdesk",
    //       href: "/",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/Our-company",
    //       title: "BigMarker",
    //       href: "/",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Swoogo",
    //       href: "/",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/Eventene",
    //       title: "Eventene",
    //       href: "/",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/Our-company",
    //       title: "GoTo Webinar",
    //       href: "/",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/Our-company",
    //       title: "PheedLoop",
    //       href: "/",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Swapcard",
    //       href: "/",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/Our-company",
    //       title: "EventX",
    //       href: "/",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Zuddl",
    //       href: "/",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/Our-company",
    //       title: "EventMobi",
    //       href: "/",
    //     },
    //     {
    //       id: 20,
    //       image: "/assets/Header/About/Our-company",
    //       title: "6Connex",
    //       href: "/",
    //     },
    //     {
    //       id: 21,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Goldcast",
    //       href: "/",
    //     },
    //     {
    //       id: 22,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Bevy",
    //       href: "/",
    //     },
    //     {
    //       id: 23,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Blackthorn Events",
    //       href: "/",
    //     },
    //     {
    //       id: 24,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Odoo Events",
    //       href: "/",
    //     },
    //     {
    //       id: 25,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Accelevents",
    //       href: "/",
    //     },
    //     {
    //       id: 26,
    //       image: "/assets/Header/About/Our-company",
    //       title: "AnyRoad",
    //       href: "/",
    //     },
    //     {
    //       id: 27,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Canapii",
    //       href: "/",
    //     },
    //     {
    //       id: 28,
    //       image: "/assets/Header/About/Our-company",
    //       title: "FLOOR by 10Times",
    //       href: "/",
    //     },
    //     {
    //       id: 29,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Glue Up",
    //       href: "/",
    //     },
    //     {
    //       id: 30,
    //       image: "/assets/Header/About/Our-company",
    //       title: "EventCreate",
    //       href: "/",
    //     },
    //     {
    //       id: 31,
    //       image: "/assets/Header/About/Our-company",
    //       title: "ON24",
    //       href: "/",
    //     },
    //     {
    //       id: 32,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Localist",
    //       href: "/",
    //     },
    //     {
    //       id: 33,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Sched",
    //       href: "/",
    //     },
    //     {
    //       id: 34,
    //       image: "/assets/Header/About/Our-company",
    //       title: "AudienceView Professional",
    //       href: "/",
    //     },
    //     {
    //       id: 35,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Explara Event Management Cloud",
    //       href: "/",
    //     },
    //     {
    //       id: 36,
    //       image: "/assets/Header/About/Our-company",
    //       title: "InEvent",
    //       href: "/",
    //     },
    //     {
    //       id: 37,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Joyn",
    //       href: "/",
    //     },
    //   ],
    // },
    // {
    //   id: 10,
    //   title: "Social Networking",
    //   socialNetworking: [
    //     {
    //       id: 1,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Tribe",
    //       href: "/",
    //     },
    //     {
    //       id: 2,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Zoho Connect",
    //       href: "/",
    //     },
    //     {
    //       id: 3,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Flock",
    //       href: "/",
    //     },
    //     {
    //       id: 4,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Yammer",
    //       href: "/",
    //     },
    //     {
    //       id: 5,
    //       image: "/assets/Header/About/Our-company",
    //       title: "eXo Platform",
    //       href: "/",
    //     },
    //     {
    //       id: 6,
    //       image: "/assets/Header/About/Our-company",
    //       title: "SocialEngine",
    //       href: "/",
    //     },
    //     {
    //       id: 7,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Whaller",
    //       href: "/",
    //     },
    //     {
    //       id: 8,
    //       image: "/assets/Header/About/Our-company",
    //       title: "HumHub",
    //       href: "/",
    //     },
    //     {
    //       id: 9,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Disciple",
    //       href: "/",
    //     },
    //     {
    //       id: 10,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Open Source Social Network",
    //       href: "/",
    //     },
    //     {
    //       id: 11,
    //       image: "/assets/Header/About/Our-company",
    //       title: "SocialBuddy",
    //       href: "/",
    //     },
    //     {
    //       id: 12,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Bitrix24",
    //       href: "/",
    //     },
    //     {
    //       id: 13,
    //       image: "/assets/Header/About/Our-company",
    //       title: "ConferenceNet",
    //       href: "/",
    //     },
    //     {
    //       id: 14,
    //       image: "/assets/Header/About/Our-company",
    //       title: "SkaDate",
    //       href: "/",
    //     },
    //     {
    //       id: 15,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Elgg",
    //       href: "/",
    //     },
    //     {
    //       id: 16,
    //       image: "/assets/Header/About/Our-company",
    //       title: "BuddyPress",
    //       href: "/",
    //     },
    //     {
    //       id: 17,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Oxwall",
    //       href: "/",
    //     },
    //     {
    //       id: 18,
    //       image: "/assets/Header/About/Our-company",
    //       title: "Jcow",
    //       href: "/",
    //     },
    //     {
    //       id: 19,
    //       image: "/assets/Header/About/Our-company",
    //       title: "friendica",
    //       href: "/",
    //     },
    //   ],
    // },
];
